export const ONBOARDING_WORKFLOW_VIEW_SCOPES = [
  'is-admin',
  'onboarding-workflow:view',
];

export const ONBOARDING_WORKFLOW_CREATE_SCOPES = [
  'is-admin',
  'onboarding-workflow:create',
];

export const ONBOARDING_WORKFLOW_UPDATE_SCOPES = [
  'is-admin',
  'onboarding-workflow:update',
];

export const ONBOARDING_WORKFLOW_CLOSED_WON_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_CREATE_SCOPES,
    'onboarding-workflow:closed-won',
  ]),
);

export const ONBOARDING_WORKFLOW_NEW_PARTNER_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_CREATE_SCOPES,
    'onboarding-workflow:new-partner',
  ]),
);

export const ONBOARDING_WORKFLOW_ACCOUNT_CHANGE_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_UPDATE_SCOPES,
    'onboarding-workflow:account-change',
  ]),
);

export const ONBOARDING_WORKFLOW_DRAFT_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_CLOSED_WON_SCOPES,
    ...ONBOARDING_WORKFLOW_NEW_PARTNER_SCOPES,
  ]),
);

export const ONBOARDING_WORKFLOW_REVIEW_SCOPES = Array.from(
  new Set([...ONBOARDING_WORKFLOW_UPDATE_SCOPES]),
);

export const ONBOARDING_WORKFLOW_MENU_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_VIEW_SCOPES,
    ...ONBOARDING_WORKFLOW_DRAFT_SCOPES,
    ...ONBOARDING_WORKFLOW_REVIEW_SCOPES,
    ...ONBOARDING_WORKFLOW_ACCOUNT_CHANGE_SCOPES,
  ]),
);

export const ONBOARDING_WORKFLOW_SUCCESS_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_DRAFT_SCOPES,
    ...ONBOARDING_WORKFLOW_REVIEW_SCOPES,
  ]),
);

/** Grants access to admins or users with view permission. Use with `useUserCanAny`. */
export const onboardingWorkflowViewScope =
  ONBOARDING_WORKFLOW_VIEW_SCOPES.join(',');
/** Grants access to admins or users with create permission. Use with `useUserCanAny`. */
export const onboardingWorkflowCreateScope =
  ONBOARDING_WORKFLOW_CREATE_SCOPES.join(',');
/** Grants access to admins or users with update permission. Use with `useUserCanAny`. */
export const onboardingWorkflowUpdateScope =
  ONBOARDING_WORKFLOW_UPDATE_SCOPES.join(',');
/** Grants access to admins or users with create+closed-won permissions. Use with `useUserCanAny`. */
export const onboardingWorkflowClosedWonScope =
  ONBOARDING_WORKFLOW_CLOSED_WON_SCOPES.join(',');
/**
 * Requires onboarding create access and the new-partner subtype permission.
 * Use with `useUserCan`, not `useUserCanAny`.
 */
export const onboardingWorkflowNewPartnerScope =
  ONBOARDING_WORKFLOW_NEW_PARTNER_SCOPES.join(',');
/** Grants access to admins or users with update+account-change permissions. Use with `useUserCanAny`. */
export const onboardingWorkflowAccountChangeScope =
  ONBOARDING_WORKFLOW_ACCOUNT_CHANGE_SCOPES.join(',');
/** Grants access to anyone eligible to create a draft (closed-won or new-partner). Use with `useUserCanAny`. */
export const onboardingWorkflowDraftScope =
  ONBOARDING_WORKFLOW_DRAFT_SCOPES.join(',');
/** Grants access to admins or users with update/review permission. Use with `useUserCanAny`. */
export const onboardingWorkflowReviewScope =
  ONBOARDING_WORKFLOW_REVIEW_SCOPES.join(',');
/** Grants access to any user with any onboarding workflow permission. Use with `useUserCanAny`. */
export const onboardingWorkflowMenuScope =
  ONBOARDING_WORKFLOW_MENU_SCOPES.join(',');
/** Grants access to users who can transition a workflow to success (draft or review). Use with `useUserCanAny`. */
export const onboardingWorkflowSuccessScope =
  ONBOARDING_WORKFLOW_SUCCESS_SCOPES.join(',');

/** Alias for `onboardingWorkflowClosedWonScope` scoped to the import flow. Use with `useUserCanAny`. */
export const onboardingWorkflowImportClosedWonScope =
  onboardingWorkflowClosedWonScope;
